import initialState from "./initialState";

export const CupSearchReducer = (
  state = initialState.cupSearchSearchCriteria,
  action
) => {
  switch (action.type) {
    case "CUP_SEARCH_FORM_DATA_REQUEST":
      return action.payload;

    default:
      return state;
  }
};
